// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Qz7DP","center":"Spinner_center__crcnQ","spinnerBlade":"Spinner_spinnerBlade__o+NY6","spinner-fade9234":"Spinner_spinner-fade9234__pH7EE"};